import { IRenter } from "@/types/renter.type";
import { Modal } from "flowbite-react";
import { FormEditSubscription } from "../forms/FormEditSubscription";
import { updateSubscription } from "@/common/services/subscription.api";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { ISubscription } from "@/types/subscription.type";

type Props = {
  onClose?: () => void;
  subscription: ISubscription;
  renter: IRenter;
}
export function ModalEditSubscription({ onClose, subscription, renter }: Props) {
  const { notifySuccess, notifyError } = useToastContext()


  async function editSubscription(subscriptionData): Promise<Partial<ISubscription> & { ok: boolean, errors?: unknown[] }> {
    try {

      const result = await updateSubscription(subscription._id!, subscriptionData);
      const { ok } = result;

      if (ok) {
        notifySuccess(`Assinatura atualizada com sucesso!`);
        // onClose?.();

        return { ok: true, errors: [] };
      }

      if (!result.ok) {
        notifyError(result.message as string);
      }

      return {
        ok: false,
        errors: [{ message: result.message || "Erro ao atualizar assinatura" }]
      };

    } catch (err) {
      console.error("Erro ao editar assinatura:", err);
      notifyError((err as Error).message);

      return {
        ok: false,
        errors: [{ message: (err as Error).message }]
      };
    }
  }

  return (
    <Modal
      show={true}
      size="4xl"
      onClose={onClose}
    >
      <Modal.Header>
        <h2 className="text-lg font-medium dark:text-black">
          Editando assinatura: {renter.name}
        </h2>
      </Modal.Header>
      <Modal.Body>
        {subscription ? (
          <FormEditSubscription
            subscription={subscription}
            renter={renter}
            onSubmit={editSubscription}
          />
        ) : (
          <p>Loading subscription data...</p>
        )}
      </Modal.Body>

    </Modal>
  )
}